module.exports = __webpack_public_path__ + "static/England-4994ccd1ebfc5d3c021b89e86f75389d.png";